var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uikit layout" }, [
    _c("div", { staticClass: "layout__title" }, [_vm._v("UIKit")]),
    _c(
      "div",
      { staticClass: "uikit__tabs" },
      [_c("c-tabs", { attrs: { items: _vm.tabs, "with-routing": "" } })],
      1
    ),
    _c("div", { staticClass: "uikit__content" }, [_c("router-view")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }